import React from 'react';
import { CheckCircle, Users, Clock, Shield } from 'lucide-react';
export const AboutUs = () => {
  const values = [{
    icon: CheckCircle,
    title: 'Quality Service',
    description: 'We deliver exceptional repair and maintenance services with attention to detail and technical excellence.'
  }, {
    icon: Users,
    title: 'Customer Focus',
    description: 'Your satisfaction is our priority. We listen to your needs and provide solutions that work for you.'
  }, {
    icon: Clock,
    title: 'Reliability',
    description: 'Count on us to arrive on time, complete repairs efficiently, and stand behind our work.'
  }, {
    icon: Shield,
    title: 'Integrity',
    description: 'We operate with transparency, honesty, and fairness in all our customer interactions.'
  }];
  return <div className="w-full" data-id="element-166">
      {/* Hero Section */}
      <div className="bg-primary py-16 md:py-24 w-full" data-id="element-167">
        <div className="container mx-auto px-4" data-id="element-168">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-169">
            About Prismedge
          </h1>
          <p className="text-xl text-white/90 max-w-3xl" data-id="element-170">
            Your trusted partner for appliance repairs and maintenance services
            across the UK.
          </p>
        </div>
      </div>
      {/* Main Content */}
      <section className="py-16 bg-light" data-id="element-171">
        <div className="container mx-auto px-4" data-id="element-172">
          <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-173">
            <div className="lg:w-1/2" data-id="element-174">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nuXQjdXAzQfXBsEre1rcrV/10.png" alt="Family watching TV" className="rounded-lg shadow-lg" data-id="element-175" />
            </div>
            <div className="lg:w-1/2" data-id="element-176">
              <h2 className="text-3xl font-bold text-primary mb-6" data-id="element-177">
                Who We Are
              </h2>
              <p className="text-gray-600 mb-4 text-lg" data-id="element-178">
                At Prismedge, we specialise in fast, professional appliance
                repairs and service plans across the UK. From kitchens to living
                rooms, our trusted engineers are here to help keep your home
                running smoothly.
              </p>
              <p className="text-gray-600 mb-4 text-lg" data-id="element-179">
                We understand that when an appliance breaks down, it can disrupt
                your daily routine and cause unnecessary stress. That's why
                we're committed to providing prompt, efficient repairs with
                minimal disruption to your home life.
              </p>
              <p className="text-gray-600 mb-4 text-lg" data-id="element-180">
                With our team of experienced, qualified technicians, we offer
                fixed-price support, UK-based service, and peace of mind for
                every home. We take pride in our work and are dedicated to
                delivering exceptional customer service with every repair.
              </p>
              <p className="text-gray-600 text-lg" data-id="element-181">
                Whether you need a one-time repair or ongoing protection through
                our comprehensive service plans, Prismedge is here to ensure
                your appliances are in safe hands.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Our Values */}
      <section className="py-16 bg-white" data-id="element-182">
        <div className="container mx-auto px-4" data-id="element-183">
          <h2 className="text-3xl font-bold text-primary mb-12 text-center" data-id="element-184">
            Our Values
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-185">
            {values.map((value, index) => <div key={index} className="bg-light rounded-lg p-6 text-center" data-id="element-186">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-primary/10 rounded-full" data-id="element-187">
                  <value.icon className="text-primary" size={28} data-id="element-188" />
                </div>
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-189">
                  {value.title}
                </h3>
                <p className="text-gray-600" data-id="element-190">{value.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-primary" data-id="element-191">
        <div className="container mx-auto px-4 text-center" data-id="element-192">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-193">
            Ready to Experience the Prismedge Difference?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto" data-id="element-194">
            Contact us today to learn more about our services or to schedule
            your appliance repair.
          </p>
          <a href="/contact-us" className="inline-block bg-secondary hover:bg-secondary/90 text-white font-bold py-3 px-8 rounded-md text-lg transition-colors" data-id="element-195">
            Get in Touch
          </a>
        </div>
      </section>
    </div>;
};